export default __webpack_public_path__ + "static/media/infoLight.4452af5f.svg";